const STORAGE_KEY = "activeBranches";

export const getActiveBranches = () => {
  if (typeof window === "undefined") return [];
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    console.error("Error reading active branches from localStorage", e);
    return [];
  }
};

export const setActiveBranches = (branches) => {
  if (typeof window === "undefined") return;
  try {
    const safeBranches = Array.isArray(branches) ? branches : [];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(safeBranches));
  } catch (e) {
    console.error("Error saving active branches to localStorage", e);
  }
};

export const clearActiveBranches = () => {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.error("Error clearing active branches from localStorage", e);
  }
};

export const getCurrentBranch = () => {
  const branches = getActiveBranches();
  return branches.length > 0 ? branches[0] : null;
};

export const getCurrentBranchId = () => {
  const current = getCurrentBranch();
  return current ? current.id : null;
};
